import React, {
  forwardRef,
} from 'react';
import { ReportPdfProps } from '../taiReportingSystem/utils/types';
import { getPageMargins } from '../ScreenReportPdf/constant';
import MorningComponentToPrint from './MorningComponentToPrint';

function ReportPdf({ printRef }:ReportPdfProps) {
  const pageMarginsCSS = getPageMargins;

  return (
    <>
      <style>{pageMarginsCSS}</style>
      <div style={{
        display: 'none', width: '900px', margin: '0 auto', backgroundColor: '#FFFFFF',
      }}
      >
        <MorningComponentToPrint ref={printRef} />
      </div>
    </>
  );
}

const ScreenMorningReportPdf = forwardRef(ReportPdf);

export default ScreenMorningReportPdf;
